// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --modal-header-font-size: 16px;
}

ion-title {
  font-size: var(--modal-header-font-size) !important;
}

ion-buttons[slot=start] ion-button,
:host ::ng-deep ion-buttons[slot=end] ion-button {
  font-size: var(--modal-header-font-size) !important;
}

ion-toolbar {
  padding-inline: 0 !important;
}

@media (max-width: 369px) {
  :host {
    --modal-header-font-size: calc(10px + 1vw);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal-header/modal-header.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;AACJ;;AAEA;EACI,mDAAA;AACJ;;AAEA;;EAEI,mDAAA;AACJ;;AAEA;EACI,4BAAA;AACJ;;AAEA;EACI;IACI,0CAAA;EACN;AACF","sourcesContent":[":host {\n    --modal-header-font-size: 16px;\n}\n\nion-title {\n    font-size: var(--modal-header-font-size) !important;\n}\n\nion-buttons[slot=\"start\"] ion-button,\n:host ::ng-deep ion-buttons[slot=\"end\"] ion-button {\n    font-size: var(--modal-header-font-size) !important;\n}\n\nion-toolbar {\n    padding-inline:0 !important;\n}\n\n@media (max-width: 369px) {\n    :host {\n        --modal-header-font-size: calc(10px + 1vw);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
